import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { PochtaTariffDimensionWrite } from './PochtaTariffDimensionWrite'
/**
* Class PochtaShowcaseTariffCalculateRequest
*  Тело калькулятора пересылки на витрине (профиль РПО — из канала / способа доставки).
*/
export class PochtaShowcaseTariffCalculateRequest extends ActiveModel {

/**
  * indexFrom
  * 
  */
  @ActiveField('')
  indexFrom: string = ''


/**
  * indexTo
  * 
  */
  @ActiveField('')
  indexTo: string = ''


  /**
  * massGrams
  * Масса, г.  */
  @ActiveField(0)
  massGrams: number = 0


  /**
  * dimension
  * Габариты для калькулятора (`dimension` в теле `/1.0/tariff`).  */
  @ActiveField({
    factory: [PochtaTariffDimensionWrite, () => undefined]
  })
  dimension?: null | PochtaTariffDimensionWrite


  /**
  * fragile
  *   */
  @ActiveField()
  fragile?: null | boolean


  /**
  * declaredValueKopecks
  *   */
  @ActiveField()
  declaredValueKopecks?: null | number


/**
  * paymentMethod
  * 
  */
  @ActiveField()
  paymentMethod?: null | string


  /**
  * deliveryMethodId
  * Способ доставки канала (Domain.Entities.Channels.ChannelPochtaDeliveryMethod или<br>Domain.Entities.Channels.ChannelPochtaCourierDeliveryMethod) для Extra* и профиля РПО; необязателен.<br>  */
  @ActiveField()
  deliveryMethodId?: null | number
}
